/**
 * 响应式断点常量（集中管理，便于维护）
 * 与 Tailwind 默认断点对齐：sm 640, md 768, lg 1024, xl 1280
 */
export const BREAKPOINTS = {
  sm: 640,
  md: 768,
  lg: 1024,
  xl: 1280,
} as const;

/** 日期格紧凑模式阈值：单格宽度小于此值时仅显示日期+底边色条 */
export const COMPACT_CELL_WIDTH = 80;

/** 媒体查询字符串，供 useMediaQuery 使用 */
export const MEDIA_QUERIES = {
  /** 手机：< 768px（含 iPad 竖屏） */
  isMobile: `(max-width: ${BREAKPOINTS.md - 1}px)`,
  /** 平板：768–1023px（iPad 横屏等） */
  isTablet: `(min-width: ${BREAKPOINTS.md}px) and (max-width: ${BREAKPOINTS.lg - 1}px)`,
  /** 桌面：≥ 1024px */
  isDesktop: `(min-width: ${BREAKPOINTS.lg}px)`,
} as const;
